<div
    class="research-child-wrapper"
    [class.research-child-wrapper--mobile]="isMobile"
>
    <div class="order-header" *ngIf="isMobile">
        <div class="order-header__return">
            <button class="close-button" (click)="closeDetails()">
                <img src="./assets/img/svg/return-btn.svg" alt="arrow_back" />
            </button>
        </div>
        <div class="order-header__text">Информация по заказу</div>
        <div class="order-header__print"></div>
    </div>

    <div class="order-data" *ngIf="isMobile">
        <div class="order-data__date">
            {{ formatFullDate(selectedOrder?.regdate) }}
        </div>
        <div class="order-data__day">{{ getDay(selectedOrder?.regdate) }}</div>
    </div>
    <div *ngIf="loadingResearchList" class="loading">
        <loader type="page"></loader>
    </div>
    <div *ngIf="!loadingResearchList" class="research-child-infinity-scroll-container">
        <div class="research-header" [class.research-header--mobile]="isMobile">
            <span class="date-research" *ngIf="!isMobile">{{
                getDateOrder(selectedOrder?.dtSort)
            }}</span>
            <span class="name-research"
                >Заказ {{ selectedOrder?.research_id }}</span
            >
            <span class="count-research">
                {{ labOrdersChild.length }}
                {{
                    strEnd(labOrdersChild.length, "Биоматериал", [
                        "",
                        "а",
                        "ов"
                    ])
                }}
            </span>
        </div>

        <div
            class="research-child-list"
            [class.research-child-list--mobile]="isMobile"
        >
            <div class="name-research__mobile" *ngIf="isMobile">
                Заказ {{ selectedOrder?.research_id }}
            </div>
            <ng-container *ngFor="let result of labOrdersChild; let i = index">
                <div
                    class="research-child-item"
                    [class.research-child-item--mobile]="isMobile"
                    (click)="openDocReseachChildModal(result, $event)"
                    [class.disabled-item]="
                        result.text_status.trim().toLowerCase() !== 'выполнен'
                    "
                >
                    <!--  -->
                    <div
                        *ngIf="isMobile"
                        class="research-child-item__save"
                        (click)="
                            goPdf(
                                result.research_id,
                                $event,
                                result.ext_results,
                                result.internal_order
                            )
                        "
                    >
                        <mat-icon
                            *ngIf="
                                result.text_status.trim().toLowerCase() ===
                                    'выполнен' &&
                                !loadingPdfIds.has(result.research_id)
                            "
                            svgIcon="print"
                            class="cls-btn-print cls-btn-icon-print-custom"
                        ></mat-icon>
                        <div
                            class="loader"
                            *ngIf="loadingPdfIds.has(result.research_id)"
                        ></div>
                        <!-- <img
                            *ngIf="loadingPdfIds.has(result.research_id)"
                            class="pdf-loader loader-rotate"
                            src="./assets/img/svg/loader-btn.svg"
                            alt=""
                        /> -->
                    </div>
                    <!-- /// -->
                    <div
                        class="research-child-row__name"
                        [class.research-child-row__name--mobile]="isMobile"
                    >
                        {{ result.specimen }}
                    </div>
                    <div
                        class="research-child-row__indicator"
                        *ngIf="isMobile"
                        [ngClass]="getStatusClassIcon(result.text_status)"
                    >
                        <img
                            *ngIf="getStatusIndicator(result.text_status)"
                            [src]="getStatusIndicator(result.text_status)"
                            class="status-indicator-icon"
                        />
                    </div>

                    <div class="research-child-row__text" *ngIf="!isMobile">
                        <div
                            class="research-child-row__text_status"
                            [ngClass]="getStatusClass(result.text_status)"
                        >
                            {{ getCapitalizedStatus(result.text_status) }}
                        </div>
                        <div
                            class="research-child-item__save"
                            (click)="
                                goPdf(
                                    result.research_id,
                                    $event,
                                    result.ext_results,
                                    result.internal_order
                                )
                            "
                        >
                            <mat-icon
                                *ngIf="
                                    result.text_status.trim().toLowerCase() ===
                                        'выполнен' &&
                                    !loadingPdfIds.has(result.research_id)
                                "
                                svgIcon="print"
                                class="cls-btn-print cls-btn-icon-print-custom"
                            ></mat-icon>
                            <div
                                class="loader"
                                *ngIf="loadingPdfIds.has(result.research_id)"
                            ></div>
                            <!-- <img
                                *ngIf="loadingPdfIds.has(result.research_id)"
                                class="pdf-loader loader-rotate"
                                src="./assets/img/svg/loader-btn.svg"
                                alt=""
                            /> -->
                        </div>
                    </div>
                </div>
                <div
                    class="research-child-expanded-content"
                    [class.slide-out]="closingItemId === result.research_id"
                    *ngIf="isMobile && isItemExpanded(result.research_id)"
                >
                    <app-reseach-child-modal
                        class="modal-details"
                        [class.modal-details--embedded]="isMobile"
                        [pickedResearch]="result"
                    ></app-reseach-child-modal>
                    <!-- (close)="showDetails = false" -->
                </div>
            </ng-container>
        </div>
    </div>
</div>
